import { type IBase } from "@/interfaces/api/base.interface"
import type { IFileBucket } from "@/interfaces/api/file-bucket.interface"
import { type IProject } from "@/interfaces/api/project.interface"
import type { IRentalDispense } from "@/interfaces/api/rental-dispense.interface"
import type { IRentalDispenseMaterialization } from "@/interfaces/api/rental-dispense-materialization.interface"
import type { ISale } from "@/interfaces/api/sale.interface"
import { type Moment } from "moment"

export interface IProductionStatement extends IBase {
  project: IProject
  fileBucket?: IFileBucket
  periodStart?: Moment
  periodEnd?: Moment
  reference?: string
  disputedAt?: Moment | null
  comment?: string
  lastSentAt?: Moment | null
  lastRemindedAt?: Moment | null

  salesSum?: string
  rentalDispenseMaterializationsSum?: string

  saleIds?: string[]
  rentalDispenseIds?: string[]
  rentalDispenseMaterializationIds?: string[]

  sales: ISale[]
  rentalDispenseMaterializations: IRentalDispenseMaterialization[]
  rentalDispenses: IRentalDispense[]
}

/**
 * A preview returned by the drafts endpoint. It deliberately has no persistent
 * production-statement id: the backend creates one only when the draft is sent.
 */
export interface IDraftProductionStatement extends IProductionStatement {
  isComplete: boolean
  hasWarnings: boolean
}

export enum VirtualProductionStatementStatus {
  TO_CREATE = 1,
  SENT = 2,
  DISPUTED = 3
}
